import Tab from './Tab'
import Panel from './Panel'

const Tabs = {
    Tab,
    Panel
}

export default Tabs